// dependencies.
import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
// components.
import AuthTemplate from '../../templates/AuthScreen'
// utils.
import notifyToast from '../../js/notifyToast'
// constants.
import { ACTIVATE_FORM } from './constants'
import {
  activateOperatorUser,
  getUserByDocument,
  getUserByDocumentAndCode,
} from '../../js/firebase/firebase'
import { signIn } from '../../js/auth/authActions'
import { useAppDispatch } from '../../js/store/hooks'
import { Loader } from '../../components/Icon'

/******************************/
/*                            */
/*    Activate User Screen    */
/*                            */
/******************************/

const ActivateOperatorScreen = () => {
  const [loaded, setLoaded] = useState(false)
  const dispatch = useAppDispatch()

  // hooks.
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  // states.
  const [values, setValues] = useState({})

  // ------------------------------------------------------------------------------------------- //
  // Handle actions                                                                              //
  // ------------------------------------------------------------------------------------------- //

  // handle update value change.
  const handleValueChange = (value) => {
    setValues(value)
  }

  // handle update activate value for user.
  const handleActivateClick = async () => {
    setLoaded(true)
    if (!values.password) {
      setLoaded(false)
      return notifyToast('Debe ingresar una contraseña', 'error')
    }

    if (values.password !== values.password2) {
      setLoaded(false)
      return notifyToast('Las contraseñas no coinciden', 'error')
    }
    const password = values.password
    values.document = searchParams.get('document')
    values.firstAccessCode = searchParams.get('code')

    try {
      await activateOperatorUser(values)
      // Si la activación se completa con éxito, intenta iniciar sesión con las credenciales proporcionadas
      const userDoc = await getUserByDocument(values.document)
      if (userDoc) {
        const email = userDoc.data().email
        dispatch(signIn({ email, password }))
        setLoaded(false)
      } else {
        setLoaded(false)
        return notifyToast('Credenciales incorrectas', 'error')
      }
    } catch (error) {
      console.error('Error al activar el usuario:', error)
      setLoaded(false)
      // Manejo del error aquí
    }
  }

  // ------------------------------------------------------------------------------------------- //
  // USER SESSION                                                                                //
  // ------------------------------------------------------------------------------------------- //

  useEffect(() => {
    // Definir la función asincrónica
    const fetchData = async () => {
      // handle not signed up users.
      if (!searchParams.get('document') || !searchParams.get('code')) navigate('/signin')
      const userDoc = await getUserByDocumentAndCode(
        searchParams.get('document'),
        searchParams.get('code')
      )
      if (!userDoc) {
        // Si no se encuentra el usuario, redirigir a la página de inicio de sesión
        notifyToast(
          'El usuario ya fue activado o venció el tiempo para activarse, se redireccionará...',
          'error'
        )
        setTimeout(() => {
          navigate(`/signin`)
        }, 5000)
      }
    }

    // Llamar a la función
    fetchData()
  }, [])
  // ------------------------------------------------------------------------------------------- //
  // CONTENT                                                                                     //
  // ------------------------------------------------------------------------------------------- //

  // return content.
  return (
    <AuthTemplate
      disbledSubmit={loaded}
      description="Para activar su cuenta, ingrese una contraseña"
      form={ACTIVATE_FORM}
      submitLabel="Activar cuenta"
      topbarTitle="Activar cuenta"
      onChange={(value) => handleValueChange(value)}
      onSubmit={() => handleActivateClick()}
    >
      {loaded && <Loader />}
    </AuthTemplate>
  )
}

// TODO: create an auth screens tempate.

export default ActivateOperatorScreen
